import React, { useEffect, useState } from 'react';

import { Theme, useTheme } from '@mui/material/styles';

import { AppBarProps as MuiAppBarProps } from '@mui/material/AppBar';
import AccountCircle from '@mui/icons-material/AccountCircle';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
// import Badge from '@mui/material/Badge';
// import MailIcon from '@mui/icons-material/Mail';
// import NotificationsIcon from '@mui/icons-material/Notifications';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';

import { useLocation } from 'react-router-dom';
import { useNavigationBlocker } from '../../system/services/navigationBlockerContext';

import { useAuthenticator } from '../../auth/AuthenticationContext';

import { AppBar } from './components/app-bar';
import { NavMenuItem } from '../../ui/app-bar';
import { ProfileMenu } from './components/profile-menu';
import { SystemTimer } from '../../system/shared/SystemTimer';

import { Logo } from '../shared/logo';

import styles from './app-bar.module.css';
import { Button, Grid, Popover, Tooltip } from '@mui/material';
import { Notifier } from '../../system/services/notificationManager';
import {
  useStatusNotifier,
  StatusMessagePanel,
} from '../../system/services/statusNotifier';
import { useInjectableComponents } from '../../system/services/injectableComponentsManager';
import { useIsSmallScreen } from '../../system/SystemMediaQueriesProvider';

interface AppBarProps extends MuiAppBarProps {
  drawerOpen: boolean;
  drawerWidth: number;
}

interface MainAppBarProps extends AppBarProps {
  theme: Theme;
  appName?: string;
  appBarItems: NavMenuItem[];
  toggleDrawer: () => void;
  handleRouteChange: (route: string) => void;
  currentRoute: string;
}

export function MainAppBar({
  drawerOpen,
  drawerWidth,
  appBarItems,
  toggleDrawer,
  currentRoute,
  handleRouteChange,
}: MainAppBarProps) {
  const auth = useAuthenticator();
  const { sessionExpiresAt, expirationWarning } = useAuthenticator();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [openPop, setPop] = React.useState(expirationWarning);
  const { title, navigateToTitlePath } = useInjectableComponents();
  const [expAnchorEl, setExpAnchorEl] = React.useState<HTMLElement | null>(
    document.getElementById('profile-menu'),
  );
  const handleCloseExpMenu = () => {
    setPop(false);
  };
  const { manageAsyncOp } = useStatusNotifier();
  const [extendButtonDisabled, setExtendButtonDisabled] =
    useState<boolean>(false);

  const [userInfo, setUserInfo] = useState<string>();
  const isMenuOpen = Boolean(anchorEl);

  const handleProfileMenuClose = () => {
    setAnchorEl(null);
  };

  const handleProfileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  useEffect(() => {
    if ((expirationWarning && !openPop) || (!expirationWarning && openPop)) {
      setExpAnchorEl(document.getElementById('profile-menu'));
      setPop(expirationWarning);
    }
  }, [expirationWarning, openPop]);

  useEffect(() => {
    setUserInfo(auth.userName || auth.user?.name.lastName || 'Not logged in');
  }, [auth]);

  const menuId = 'primary-search-account-menu';

  const profileMenuProps = {
    menuId: 'profile-menu',
    anchorEl: anchorEl,
    isMenuOpen: isMenuOpen,
    handleMenuClose: handleProfileMenuClose,
    handleRouteChange: handleRouteChange,
    appBarItems: appBarItems,
  };

  const theme = useTheme();
  const isSmall = useIsSmallScreen();

  const { navigateWithInterceptor } = useNavigationBlocker();
  const location = useLocation();

  const { pathname } = location;
  const pathParts = pathname.split('/');
  const topSegment = pathParts[1];
  const propertyId = pathParts[2];
  const titleFallbackPath =
    topSegment === 'properties' && propertyId
      ? `/properties/${propertyId}`
      : `/${topSegment ?? ''}`;

  return (
    <div style={{ height: '64px' }}>
      <AppBar
        className={styles.appBar}
        position="fixed"
        drawerOpen={drawerOpen}
        drawerWidth={drawerWidth}
      >
        <Toolbar>
          {/* Hamburger */}
          <IconButton
            color="inherit"
            edge="start"
            aria-label="open menu"
            onClick={toggleDrawer}
            sx={{
              paddingBottom: 0,
              mr: 0,
              ...(drawerOpen && { display: 'none' }),
            }}
          >
            <MenuIcon />
          </IconButton>
          {/* Logo */}
          <IconButton
            aria-label="Embue"
            sx={{
              width: '74px',
              ...(drawerOpen && { display: 'none' }),
            }}
            onClick={() => navigateWithInterceptor('/properties')}
          >
            <Logo />
          </IconButton>
          {/* -- AppBar Title */}
          <Button
            aria-label="property title"
            sx={{
              width: '100%',
              minWidth: '200px',
              display: 'flex',
              justifyContent: 'start',
              textTransform: 'none',
            }}
            onClick={() => navigateToTitlePath(titleFallbackPath)}
          >
            <Typography
              component="div"
              variant="h4"
              noWrap
              color="secondary"
              sx={{
                marginLeft: '0px',
                padding: '0px',
                display: 'flex',
                flex: '1 1 auto',
                justifyContent: 'center',
                textAlign: isSmall ? 'center' : 'left',
                overflow: 'inherit',
                fontWeight: 'bold',
                whiteSpace: 'normal',
              }}
            >
              {/*{appName ? appName : 'Super (default)'}&nbsp;*/}
              {title ?? currentRoute}
            </Typography>
          </Button>
          {isSmall ? null : <Box sx={{ flexGrow: 1 }} />}
          {/*<SearchInput />*/}
          <Box
            style={{
              display: 'flex',
              flex: '1 1 auto',
              justifyContent: 'end',
            }}
          >
            {/*<Box sx={{ display: { xs: 'none', md: 'flex' } }}>*/}
            {/*<IconButton*/}
            {/*  size="large"*/}
            {/*  aria-label="show 4 new mails"*/}
            {/*  color="inherit"*/}
            {/*>*/}
            {/*  <Badge badgeContent={4} color="error">*/}
            {/*    <MailIcon />*/}
            {/*  </Badge>*/}
            {/*</IconButton>*/}
            {/*<IconButton*/}
            {/*  size="large"*/}
            {/*  aria-label="show 17 new notifications"*/}
            {/*  color="inherit"*/}
            {/*>*/}
            {/*  <Badge badgeContent={17} color="error">*/}
            {/*    <NotificationsIcon />*/}
            {/*  </Badge>*/}
            {/*</IconButton>*/}
            <Tooltip title={userInfo}>
              <IconButton
                size="large"
                edge="end"
                aria-label="account of current user"
                aria-controls={menuId}
                aria-haspopup="true"
                onClick={handleProfileMenuOpen}
                color="secondary"
                sx={{ mr: 0, padding: isSmall ? 0 : '8px' }}
              >
                <>
                  <span
                    style={{
                      marginRight: '6px',
                      fontSize: '16px',
                      display: isSmall ? 'none' : 'inherit',
                    }}
                  >
                    {userInfo}
                  </span>
                  <span>
                    <AccountCircle
                      sx={{
                        fontSize: '1.3em',
                      }}
                    />
                  </span>
                </>
              </IconButton>
            </Tooltip>
          </Box>
        </Toolbar>
        <StatusMessagePanel />
        <ProfileMenu {...profileMenuProps} />
      </AppBar>

      <Popover
        open={Boolean(openPop)}
        anchorEl={expAnchorEl}
        onClose={() => {
          handleCloseExpMenu();
        }}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        sx={{
          width: 'auto',
          height: 'auto',
        }}
      >
        <Box
          sx={{
            px: 4,
            py: 2,
            width: isSmall ? 200 : 300,
            height: 'auto',
          }}
        >
          <Grid container>
            <Grid item xs={12}>
              <Typography
                component="div"
                align="center"
                width="100%"
                // sx={{ display: 'inherit' }}
              >
                <SystemTimer
                  expirationTimestamp={sessionExpiresAt || new Date()}
                  label={isSmall ? '' : 'Session'}
                  prefix={isSmall ? 'Logout in' : 'expiring in'}
                  completedMessage="expired"
                />
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Tooltip title="Click to extend session time">
                <div
                  style={{
                    paddingTop: '10px',
                    borderTop: '1px solid lightgray',
                    marginLeft: '10px',
                    marginTop: '10px',
                    display: 'flex',
                    justifyContent: 'space-evenly',
                  }}
                >
                  <Button
                    type="submit"
                    variant="contained"
                    color="secondary"
                    sx={{ color: '#fff' }}
                    onClick={() => {
                      if (!extendButtonDisabled) {
                        setExtendButtonDisabled(true);
                        setTimeout(() => {
                          manageAsyncOp(
                            'extendSession',
                            true,
                            'Extending session ...',
                          );
                          setTimeout(() => {
                            auth
                              .extendSessionTime()
                              .then(() => {
                                Notifier.info('Session extended successfully');
                                handleCloseExpMenu();
                              })
                              .catch((extendError) => {
                                Notifier.error(extendError.message);
                              })
                              .finally(() => {
                                manageAsyncOp('extendSession', false);
                                setExtendButtonDisabled(false);
                              });
                          });
                        });
                      }
                    }}
                  >
                    Extend
                  </Button>
                </div>
              </Tooltip>
            </Grid>
          </Grid>
        </Box>
      </Popover>
    </div>
  );
}
